const formatTime12Hour = timeStr => {
  if (!timeStr || typeof timeStr !== "string") {
    return "-"
  }

  const parts = timeStr.trim().split(":")
  if (parts.length < 2) {
    return timeStr
  }

  let hours = Number(parts[0])
  const minutes = String(Number(parts[1])).padStart(2, "0")

  if (Number.isNaN(hours) || Number.isNaN(Number(parts[1]))) {
    return timeStr
  }

  const meridiem = hours >= 12 ? "PM" : "AM"
  hours = hours % 12 || 12

  return `${hours}:${minutes} ${meridiem}`
}

export default formatTime12Hour
